module.exports = __webpack_public_path__ + "static/media/fiftygoals.82918d0a.jpg";